import React from "react";
import Footer from "../Components/Footer";
import CTASection from "../Components/CTASection";
import { Link } from "react-router-dom";
import Image4 from "../Images/image 7.png";
import Image5 from "../Images/image 5.png";
import Image6 from "../Images/image 6.png";
import "../Styles/ServicesPage.css";

function ServicesPage() {
  return (
    <div className="services-page">
      <section className="inner-hero">
        <div className="inner-hero-bg">
          <img src={Image4} alt="" className="inner-hero-img" />
        </div>
        <div className="inner-hero-overlay"></div>
        <div className="inner-hero-content">
          <span className="section-label">WHAT WE OFFER</span>
          <h1>Our Services</h1>
          <p>Comprehensive stucco and drywall solutions for every project</p>
          <div className="inner-hero-breadcrumb">
            <Link to="/">Home</Link> <span>/</span> Services
          </div>
        </div>
      </section>

      <section className="sp-services">
        <div className="sp-services-inner">
          <div className="sp-header">
            <span className="section-label">OUR EXPERTISE</span>
            <h2>What We Do Best</h2>
            <p>Professional services tailored to your needs with premium quality materials and expert craftsmanship.</p>
          </div>

          <div className="sp-grid">
            <div className="sp-card">
              <div className="sp-card-image"><img src={Image4} alt="Drywall Painting" /><div className="sp-card-badge">01</div></div>
              <div className="sp-card-content">
                <h3>Drywall Painting</h3>
                <p>From small repairs to complete remodels, no job is too big or too small. Our expert painters deliver flawless finishes with premium paints that stand the test of time.</p>
                <Link to="/services/drywall-painting" className="sp-card-btn">Learn More →</Link>
              </div>
            </div>

            <div className="sp-card">
              <div className="sp-card-image"><img src={Image5} alt="Demolition Repair" /><div className="sp-card-badge">02</div></div>
              <div className="sp-card-content">
                <h3>Demolition Repair</h3>
                <p>Removing and disposing of damaged or outdated drywall and replacing it with new materials. We restore your walls to perfect condition with seamless finishes.</p>
                <Link to="/services/demolition-repair" className="sp-card-btn">Learn More →</Link>
              </div>
            </div>

            <div className="sp-card">
              <div className="sp-card-image"><img src={Image6} alt="Popcorn Removal" /><div className="sp-card-badge">03</div></div>
              <div className="sp-card-content">
                <h3>Popcorn Removal</h3>
                <p>Modernize your ceilings with professional popcorn texture removal. We scrape, skim coat, sand, and finish for a smooth, contemporary look.</p>
                <Link to="/services/popcorn-removal" className="sp-card-btn">Learn More →</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sp-process">
        <div className="sp-process-inner">
          <span className="section-label">HOW WE WORK</span>
          <h2>Our Process</h2>
          <div className="process-steps">
            <div className="process-step"><div className="process-step-number">1</div><h4>Consultation</h4><p>Free on-site assessment and detailed estimate</p></div>
            <div className="process-connector"></div>
            <div className="process-step"><div className="process-step-number">2</div><h4>Planning</h4><p>Material selection and scheduling</p></div>
            <div className="process-connector"></div>
            <div className="process-step"><div className="process-step-number">3</div><h4>Execution</h4><p>Professional installation by experts</p></div>
            <div className="process-connector"></div>
            <div className="process-step"><div className="process-step-number">4</div><h4>Completion</h4><p>Final inspection and satisfaction guarantee</p></div>
          </div>
        </div>
      </section>

      <CTASection />
      <Footer />
    </div>
  );
}

export default ServicesPage;
